import { useAdminExamLocationDetail } from '@exam-center/admin-exam-center-location-details';
import { AdminExamLocationUsageList } from '@exam-center/admin-exam-location-usage-list';
import { RoomStatus } from '@exam-center/graphql';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams, Navigate } from '@exam-center/router';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamCenterLocationUsagePage() {
  const { roomId } = useParams('/admin/exam-location/locations/:roomId/usage');
  const { examRoomInfo } = useAdminExamLocationDetail();

  if (examRoomInfo.status === RoomStatus.Retired) {
    return <Navigate to='/admin/exam-location/locations/:roomId' params={{ roomId }} replace />;
  }

  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW]}
    >
      <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
        <PaperSection title='สิทธิ์การใช้งาน'>
          <Flex sx={(theme) => ({ flexGrow: 1, p: theme.spacing(6) })}>
            <AdminExamLocationUsageList roomId={roomId} />
          </Flex>
        </PaperSection>
      </Flex>
    </PermissionGuard>
  );
}
